export const defaultProfileAccordions = [
  'personal_info',
  'protected_information',
  'social_profiles',
  'work_experience',
  'skills',
  'additional_documents',
  'resumes',
  'langauge',
  'education_history',
  'job_preference',
  'professional_reference',
  'notification_preference',
  'change_password',
];
